export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesquisar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para selecionar quais colunas exibir"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Colunas exibidas"])}
}